import clsx from 'clsx'
import React, { CSSProperties } from 'react'

import s from './styles.module.scss'

import { HelpMeButton } from '../../../components/molecules/help-me'

const EmptyStateHelpMe = ({
  title,
  description,
  children,
  className,
  style,
}: {
  title: string
  description: string
  children: React.ReactNode
  className?: string
  style?: CSSProperties
}) => {
  return (
    <div className={clsx(s.emptyState, className)} style={style}>
      <span className={s.labelEmptyState}>{title}</span>
      {children}
      <span className={s.labelEmptyState}>{description}</span>
      <HelpMeButton />
    </div>
  )
}
export default EmptyStateHelpMe
